import { render, staticRenderFns } from "./CategoryTemplate.vue?vue&type=template&id=55f60888"
import script from "./CategoryTemplate.vue?vue&type=script&lang=js"
export * from "./CategoryTemplate.vue?vue&type=script&lang=js"
import style0 from "./CategoryTemplate.vue?vue&type=style&index=0&id=55f60888&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports